import { i18nMark } from 'lingui-react';

const messages = {
  collapseAll: i18nMark('Collapse All'),
  expandAll: i18nMark('Expand All'),
};

export default messages;



// WEBPACK FOOTER //
// ./compositions/DiagnosticsWidget/messages.js